import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AlertTriangle, ExternalLink } from "lucide-react";
import { NeuCard } from "../../../components/neu/Neu";
import { delinquentCompanies } from "../../../api/platform";

// الشركات التي فشل تجديد اشتراكها — لمتابعة مالك المنصة.
export const DelinquentCard = () => {
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    delinquentCompanies()
      .then((res) => setRows(res.companies || []))
      .catch(() => setRows([]));
  }, []);

  return (
    <NeuCard data-testid="delinquent-card">
      <p className="label-xs flex items-center gap-2">
        <AlertTriangle className="h-4 w-4 text-destructive" /> {t("system.payLate")}
      </p>
      <p className="mt-1 text-xs text-muted-foreground">{t("system.payLateHint")}</p>
      {rows.length ? (
        <ul className="mt-4 grid gap-2">
          {rows.map((row) => (
            <li
              key={row.company_id}
              className="neu-in grid gap-1 rounded-2xl px-4 py-3"
              data-testid={`delinquent-${row.serial}`}
            >
              <div className="flex flex-wrap items-center justify-between gap-2">
                <p className="text-sm font-bold">{row.name}</p>
                <span className="font-mono text-xs font-bold text-destructive">{row.subscription_status}</span>
              </div>
              <p className="font-mono text-xs text-muted-foreground num">
                #{row.serial} · {row.contact_email || "—"}
              </p>
              {row.last_failure ? (
                <p className="text-xs text-muted-foreground num">
                  {(row.last_failure.at || "").slice(0, 10)} ·{" "}
                  {Number(row.last_failure.amount).toFixed(2)} {String(row.last_failure.currency).toUpperCase()} ·{" "}
                  {t("system.payAttempts", { count: row.last_failure.attempts })}
                  {row.last_failure.hosted_url ? (
                    <a
                      href={row.last_failure.hosted_url}
                      target="_blank"
                      rel="noreferrer"
                      className="ms-2 inline-flex items-center gap-1 font-bold text-primary"
                    >
                      <ExternalLink className="h-3 w-3" /> Stripe
                    </a>
                  ) : null}
                </p>
              ) : null}
            </li>
          ))}
        </ul>
      ) : (
        <p className="mt-4 text-xs font-bold text-primary" data-testid="delinquent-empty">
          {t("system.payLateNone")}
        </p>
      )}
    </NeuCard>
  );
};
